import { useMemo } from "react";
import { useRouteLoaderData } from "react-router";

import { buildProofStrip } from "~/feature/getUpdates/utils/proofStrip.util";
import type { IMetrics } from "~/types/metrics";

interface ILayoutLoaderData {
  metrics: IMetrics | null;
}

export const useGetUpdatesMetrics = () => {
  const loaderData = useRouteLoaderData("routes/layout") as
    | ILayoutLoaderData
    | undefined;
  const metrics = loaderData?.metrics;

  return useMemo(() => buildProofStrip(metrics), [metrics]);
};
